import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ProgressBarMode } from '@angular/material/progress-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'src/app/services/api/message.service';
import { SecurityService } from 'src/app/services/security.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Client } from 'src/app/interfaces/client';
import { Title } from '@angular/platform-browser';
import { DirectoryFormComponent } from '../../modules/directory-form/directory-form.component';
import { UserService } from 'src/app/services/user.service';
import { SharedDirectoryService } from 'src/app/services/api/shared-directory.service';
import { Subscription } from 'rxjs';
import { SharedDirectoryToSendService } from 'src/app/services/shared/shared-directory-to-send.service';
import { Directory } from 'src/app/interfaces/directory';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']
})
export class CreateComponent implements OnInit, OnDestroy {

    public title : string = "Medimail Patient - Nouveau message";

    //@ts-ignore
    public messageForm: FormGroup;

    //@ts-ignore
    public attachmentsArray : any[] = [];

    //@ts-ignore
    @ViewChild('fileInput') fileInput: ElementRef;
    public fileAttr = 'Sélectionner un/plusieurs fichier(s)';
 
    value = 0; // Valeur en pourcentage

    totalSize = 0; // valeur en byte

    maxSize = 50000000; // 50Mo max

    public errorMessage: string ;
    public errorType: string ;

    closeResult = '';
    //@ts-ignore
    clients: Client;

    recipient: string = '';

    directoryToSend: Directory[] = [];
    subscription: Subscription | undefined;
    
    constructor(public userService: UserService, 
                public route: Router, 
                public activeRoute: ActivatedRoute,
                private sharedDirectoryService: SharedDirectoryService,
                public messageApi: MessageService,
                private modalService: NgbModal,
                private sharedDirectoryToSendService: SharedDirectoryToSendService,
                private titleService: Title) 
    { 
        this.errorMessage = "";
        this.errorType = "";
        this.titleService.setTitle(this.title);
    }

    ngOnInit(): void {
 
        this.activeRoute.queryParams.subscribe((params) => {
            this.recipient = params.recipient;
        });

        this.messageForm = new FormGroup({
            destinataire: new FormControl(this.recipient, [Validators.required]),
            objet: new FormControl(''),
            content: new FormControl('', [Validators.required]),
            attachments: new FormControl(''),
            client: new FormControl('')
        });

        this.subscription = this.sharedDirectoryToSendService.sharedDirectory.subscribe((directories: Directory[]) => {
            this.directoryToSend = directories;
        });
    }

    ngOnDestroy() {
        this.sharedDirectoryToSendService.resetDirectory();
        this.subscription?.unsubscribe();
    }

    private updateProgressBar() {

        let size = 0;

        // On calcule la taille totale des PJ ajoutée
        this.attachmentsArray.forEach((file: File) => {
            size = size + file.size;
        });

        this.totalSize = size;

        // Si la taille est supérieure à 0 on met à jour la progress bar
        if (size > 0) {
            this.value = Math.round(100 * size / this.maxSize); // On calcule le pourcentage de place restante (sur 50 Mo)
            if (this.value == 0) { // Si la taille est égale à 0 on affiche quand même 1%
                // Mise à jour champs HTML progress bar
                this.value = 1;
                this.updateBar(this.value.toString());
            } else { // Sinon on affiche le vrai pourcentage
                // Mise à jour champs HTML progress bar
                this.updateBar(this.value.toString());
            } 
        } else if (size == 0) { // Si la taille est à 0 (plus de PJ) on met à jour la progress bar à 0
            this.value = 0;
            // Mise à jour champs HTML progress bar
            this.updateBar(this.value.toString());
        }
    }

    private updateBar(value: string) {
        // Mise à jour champs HTML progress bar
        document.getElementById("progress-bar")?.setAttribute("aria-valuenow", value);
        document.getElementById("progress-bar")?.setAttribute("style", "width: " + value + "%");
        document.getElementById("progress-bar")!.innerHTML = value + "%";
    }

    public removeAttachment(index: number) {
        this.attachmentsArray.splice(index,1);
        this.updateProgressBar();
        this.errorType = "SUCCESS";
        this.errorMessage = "CREATE.FORM.ATTACHMENT-REMOVE";
    }
  
    public hasError = (controlName: string, errorName: string) => {
        return this.messageForm.controls[controlName].hasError(errorName);
    }

    public send = (messageFormValue: any, client: Client) => {
        messageFormValue.attachments = this.attachmentsArray;
        messageFormValue.client = client;
        messageFormValue.destinataire = this.sharedDirectoryToSendService.getDirectory();
        
        this.messageApi.send(messageFormValue).subscribe((res) => {
            if (res.result == 'SUCCESS') {
                this.route.navigate(['/folders', this.userService.currentUser.symfonyUser.defaultFolder]);
            } else {
                this.errorType = res.result;
                this.errorMessage = res.content;
            }
        });
    }

    public addAttachments = (attachments: any) => {
        if (attachments.files) {
            //@ts-ignore
            Array.from(attachments.files).forEach((file: File) => {
                if (!this.isAttachmentAllowed(file)) {
                    this.errorMessage = "ERRORS.CREATE.WRONG-FILE-FORMAT";
                    this.errorType = "ERROR"; 
                } else {
                    this.fileAttr += file.name + ' - ';
                    let fileReader = new FileReader();
                    fileReader.onload = (e) => {
                        let text = fileReader.result;
                        let totalFileSize = this.totalSize + file.size;
                        if (totalFileSize < this.maxSize) {
                            this.attachmentsArray.push({"name" : file.name, "content" : text, "size" : file.size });
                            this.updateProgressBar();
                            this.errorMessage = "CREATE.FORM.ATTACHMENT-ADD";
                            this.errorType = "SUCCESS";
                        } else {
                            this.errorMessage = "ERRORS.CREATE.MAX-SIZE";
                            this.errorType = "ERROR";
                        }  
                    }
                    fileReader.readAsDataURL(file);
                }
            });
        }
    }

    private isAttachmentAllowed(attachment: File) {

        if (attachment.type == "") {
            return false;
        }


        return true;
    }

    public open(content: any) {
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    public directory() {
        this.sharedDirectoryService.getAccess().subscribe((res) => {
            if (res.result == "SUCCESS") {
                const modal = this.modalService.open(DirectoryFormComponent, {size: 'xl', centered: true, animation: true});

                var dests = [];
                if (this.messageForm.controls['destinataire'].value) {
                    var signatories = this.messageForm.controls['destinataire'].value;
                    if (signatories.includes(";")) {
                        dests = signatories.split(';');
                    } else {
                        dests.push(this.messageForm.controls['destinataire'].value);
                    }
                }
                
                modal.componentInstance.signatories = dests;
                modal.componentInstance.accessDirectory = res.content;
                modal.componentInstance.signatoriesEvent.subscribe(($e: any) => {
                    this.messageForm.patchValue({destinataire: $e.join(";")});
                });
            } else {
                this.errorMessage = res.content;
                this.errorType = res.result;
            }
        });
        
    }
}
